import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parsePricesSearch } from "@/features/catalog";
import { PricesPage } from "@/features/catalog/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/catalog/prices")({
  validateSearch: strictSearch(parsePricesSearch),
  component: Prices,
});

function Prices() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <PricesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(serviceId) =>
        router.buildLocation({ to: "/catalog/services/$serviceId", params: { serviceId } }).href
      }
      onOpen={(serviceId) =>
        void router.navigate({ to: "/catalog/services/$serviceId", params: { serviceId } })
      }
    />
  );
}
